export class SAPstatus {

    /*
    * status
     */
    samcaStatusId: string;
  
    /*
     * description
     */
    description: string;
  
    /*
     * color
     */
    color: string;
  
    /**
     * Create
     *
     * @param jsonData Json data
     *
     * @returns this
     */
    public static create(jsonData?) {
      const self = new this();
      Object.keys(jsonData).forEach(key => {
        self[key] = jsonData[key];
      });
      return self;
    }
  
    static createFromJson(json: object): SAPstatus {
      const self = new this();
  
      Object.keys(json).forEach(key => {
        self[key] = json[key];
      });
  
      return self;
    }
  }